import { createContext } from "react";
import type {
  PaymentSession,
  CreateSessionInput,
  EnabledMethods,
} from "./types";

export type PaymentContextValue = {
  session: PaymentSession | null;
  isLoading: boolean;
  error: Error | null;
  enabledMethods: EnabledMethods;
  createSession: (
    input: CreateSessionInput,
    signal?: AbortSignal,
  ) => Promise<PaymentSession | undefined>;
  recreateSession: (
    input: CreateSessionInput,
    signal?: AbortSignal,
  ) => Promise<PaymentSession | undefined>;
};

export const PaymentContext = createContext<PaymentContextValue | null>(null);
